
import _CONST from '@/const/index';
// 获取是否新版本的路由
export const handleIsNewVersionPath = (path) => {
  console.log('handleIsNewVersionPath', path)
  // 用 userInfo.id 判断登录状态（Token 改为 HttpOnly Cookie 后无法通过 JS 读取）
  const userInfoStr = localStorage.getItem('userInfo')
  const isLoggedIn = userInfoStr && JSON.parse(userInfoStr).id
  if (isLoggedIn && path && path !== '/' && path !== '/login') {
    return path.startsWith('/overview/')
    // const newOldRouteMap = _CONST.newOldRouteMap
    // 只触发一次
    // return newOldRouteMap.find(item => {
    //     console.log('------------------','newRouter',item.newRouter.replace("/:id","") , 'path',path)
    //     return item.newRouter.replace("/:id","") === path
    // })
  }
  return false
}
